/**
 * @description: 仓库管理-报损单
 * @author: hwx
 * @update: lyr(2022-03-17)
 */
<template>
    <div class="reported-loss">
        <div class="purchase_list" v-show="!showdetail">
            <div class="row row-margin">
                <button type="button" class="btn btn-flat btn-middle btn-orange" id="add-perchase-record" @click="addPurchase">新增报损单</button>
            </div>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div @click="clearDate" ref="time">
                        <input type="text" class="form-control laydate-icon" :value="startTime"> -
                        <input type="text" class="form-control laydate-icon" :value="endTime">
                    </div>
                </div>
                <label class="list-label-4">门店名称:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">报损仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control select2" ref="stock" data-placeholder="请选择仓库"></select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2">
                    <div class="input-group">
                        <input type="text" class="form-control" ref="operator" placeholder="请选择操作人" v-model="operator" @blur="nowCon" />
                        <div class="input-group-btn">
                            <ul class="dropdown-menu dropdown-menu-right" role="menu" id="operatorDown" ref="operatorDown"></ul>
                        </div>
                    </div>
                </div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryList">查询</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="reportedLossList"></table>
            </div>
        </div>

        <!-- detail -->
        <div class="detail-panel" v-show="showdetail">
            <div class="row row-margin">
                <div class="col-md-2" v-show="visible">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="addGoods">添加商品</button>
                </div>
                <div class="col-md-2" v-show="visible">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" id="breakageSave" @click="submitPurchase">保存</button>
                </div>
                <div class="col-md-2">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="showdetail=false">返回</button>
                </div>
                <div class="col-md-2" v-show="!visible">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="getExportSet">导出</button>
                </div>
            </div>
            <div class="gray-head">
                <div class="page-title">{{pagetitle}}</div>
                <div class="comment">注释：报损单是用于物品损坏后填写的单据</div>
                <div class="gray-center">
                    <div class="row row-margin">
                        <label class="col-md-1" v-show="showNumandTime">单号：</label>
                        <span class="col-md-3" v-show="showNumandTime">{{theDetail.number}}</span>
                        <label class="col-md-1">门店:</label>
                        <div class="col-md-3 ct-col">
                            <select class="form-control" ref="detailshop" data-placeholder="请选择门店" disabled></select>
                        </div>
                        <label class="col-md-1">备注:</label>
                        <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="请输入备注" v-model="remark" ref="remark" />
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-1" v-show="showNumandTime">时间：</label>
                        <span class="col-md-3" v-show="showNumandTime">{{theDetail.create_time}}</span>
                        <label class="col-md-1">报损仓库:</label>
                        <div class="col-md-3 ct-col">
                            <select class="form-control" ref="add_stock_name" data-placeholder="请选择仓库" disabled></select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="detaillist"></table>
            </div>

            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="export_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
                            <label>商品单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="quantity">
                            <label>报损数量</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='export_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='export_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- pop -->
            <div class="add-goods" ref="addgoods">
                <div class="row">
                    <div class="col-md-3 ct-col clear-pd">
                        <select class="form-control" data-placeholder="商品类型" ref="goodtype">
                            <option value=""></option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="请输入商品名称" ref="goodname" @keyup.13="queryGoods" />
                    </div>
                    <div class="pull-right">
                        <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryGoods">查询</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="goodslist"></table>
                </div>
                <div class="row btns">
                    <button type="button" class="btn btn-flat btn-small btn-orange" id="pop-save" @click="saveGoods">保存</button>
                    <button type="button" class="btn btn-flat btn-small btn-gray" @click="closeLayer">取消</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'reported_loss',
        data() {
            return {
                showdetail: false, //控制采购进货详情页显示
                showNumandTime: false, //控制详情页单号和时间的显示
                preshopid: "",//下拉框上次选中值
                preremainid: "",
                pagetitle: "",
                startTime: "",
                endTime: "",
                visible: false, //控制详情页“新增”、“保存”按钮显示
                shop: {
                    value: []
                },
                detailshop: [],
                detailsupplier: [],
                theDetail: { //
                    type: Object
                },
                purchase_list: [],
                detail_list: [],
                goodsType_list: [],
                selectdata: [],
                operator: "",
                remark: "",

                export_allcheck: false,
                c_export_allcheck: false,
                export_checkModel: [],
                export_checkData: ['goods_name', 'goods_unit_name', 'goods_type_name', 'quantity'],
                export_type: 1,
            }
        },
        watch: {
            export_checkModel: {
                handler: function(val, oldVal) {
                    if(this.export_checkModel.length >= this.export_checkData.length) {
                        this.export_allcheck = true;
                        this.c_export_allcheck = true;
                    } else {
                        this.export_allcheck = false;
                        this.c_export_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            this.$nextTick(function() {
                // 日期
                var myDate = new Date();
                this.IntstartTime = myDate;
                this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
                this.IntstartTime.setHours(8, 0);
                this.IntendTime.setHours(8, 0);
                var timStar = new Date(this.IntstartTime),
                    year = timStar.getFullYear(),
                    month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth()     + 1),
                    day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
                    hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
                    minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
                var timEnd = new Date(this.IntendTime),
                    yearend = timEnd.getFullYear(),
                    monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
                    dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
                    hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
                    minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
                this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
                this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
                this.innitDate();
                this.getshopdata(); // 门店数据
                this.getOperatorData(); // 操作人数据
                // this.innitShopInput(); //初始化门店输入框
                // this.innitSupplierInput(); //初始化供应商输入框
            });
            this.initi_list_box('');
        },
        filters: {
            formateMoney: function(value) {
                if(value < 0) {
                    return "0.00";
                } else {
                    return(value - 0).toFixed(2);
                }
            }
        },
        methods: {
            innitTable: function() {
                const _this = this;
                $(_this.$refs.reportedLossList).bootstrapTable("destroy");
                $(_this.$refs.reportedLossList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getReportedLossList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "number",
                        title: "报损单号",
                        width: "15%"
                    }, {
                        field: "create_time",
                        title: "报损日期",
                        width: "15%"
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "10%"
                    }, {
                        field: "store_name",
                        title: "报损仓库",
                        width: "10%"
                    }, {
                        field: "num",
                        title: "报损总量",
                        width: "10%"
                    }, {
                        field: "buying_price",
                        title: "报损总额",
                        width: "10%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "10%"
                    }, {
                        field: "remark",
                        title: "备注",
                        width: "10%"
                    }, {
                        title: "操作",
                        width: "10%",
                        events: {
                            'click .detail': function(e, value, row) {
                                _this.initi_add_shop_name('detail', row.shop_id, row.store_id, row.id);
                                // _this.getDetail(row.id);
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue detail">详情</span>'
                        }
                    }],
                    data: _this.purchase_list
                });
            },
            // 获取报损单列表
            getReportedLossList: function(params) {
                // debugger;
                let _this = this,
                    shop_id = $(_this.$refs.shop).val(),
                    supplier_id = "",
                    store_id = "",
                    pageNumber = 1,
                    admin_id = $(_this.$refs.operator).attr('data-id');

                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                if($(_this.$refs.stock).val() !== null && $(_this.$refs.stock).val() != "") {
                    store_id = $.trim($(_this.$refs.stock).val());
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "shop_id": shop_id, // 门店id
                            "store_id": store_id,
                            "admin_id": admin_id == 'aaa' ? "" : admin_id, // 操作人
                            "start_time": _this.startTime,
                            "end_time": _this.endTime
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getDamageList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取报损单详情
            getDetail: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                layer.load(0, {
                    shade: [0.1, '#ececec'] // 0.1透明度的白色背景
                });
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getDamageDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        layer.closeAll();
                        if(data.response.result_code == "true") {
                            _this.pagetitle = "报损单详情";
                            $(_this.$refs.detaillist).bootstrapTable('destroy');
                            _this.theDetail = data.response.result;
                            _this.visible = false;
                            _this.detail_list = data.response.result.goods;
                            _this.innitDetailTable(false);
                            $(_this.$refs.detaillist).bootstrapTable('hideColumn', 'op'); // 隐藏操作列
                            // 门店
                            let p_shop_id = data.response.result.shop_id - 0;
                            $(_this.$refs.detailshop).val(p_shop_id).trigger("change");
                            // 仓库
                            let p_add_stock_name = data.response.result.store_id - 0;
                            $(_this.$refs.add_stock_name).val("").trigger("change");
                            $(_this.$refs.add_stock_name).val(p_add_stock_name).trigger("change");
                            // 备注
                            _this.remark = data.response.result.remark;
                            $(_this.$refs.remark).prop("disabled", true);
                            _this.showNumandTime = true;
                            _this.showdetail = true;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.closeAll();
                        layer.msg("出错啦");
                    }
                });
            },
            initi_list_box: function(boxdatas) {
                $(this.$refs.stock).html("");
                $(this.$refs.stock).select2({
                    data: boxdatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },
            // 门店数据
            getshopdata: function() {
                let _this = this;

                let shopDatas = [];
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl+"PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code']=="true"){
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    shopDatas.push({ id: v.id, text: v.name });
                                }
                            });
                            $(_this.$refs.shop).select2({
                                data: shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.stock).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.stock).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                            });
                            $(_this.$refs.shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.stock).prop("disabled", false);
                            _this.getstockdata(data.response.result[1].id);
                            _this.innitTable();

                            _this.selectdata = shopDatas;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 仓库数据
            getstockdata: function(shop_id, type, cur_id, info, rowid) {
                var _this = this;
                var boxdatas = [{ id:" ", text: "全部" }];
                var datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl+"PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code']=="true"){
                            if(info == 'detail') {
                                _this.getDetail(rowid);
                            }
                            if(type=="false"){
                                _this.shop_stockdata = [];
                                $.each(data['response']['result'], function(k, v) {
                                    _this.shop_stockdata.push({ id: v.id, text: v.name });
                                });
                                $(_this.$refs.add_stock_name).html("");
                                $(_this.$refs.add_stock_name).select2({
                                    data: _this.shop_stockdata,
                                    minimumResultsForSearch: -1,
                                    language: "zh-CN",
                                    width: '100%'
                                });
                                return;
                            }
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(boxdatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 操作人数据
            getOperatorData: function() {
                var _this = this;
                var datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {}
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl+"User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code']=="true") {
                            let lsDatas = [{ id:"aaa", name: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                lsDatas.push({ id: v.id, name: v.name });
                            });
                            _this.init_operator_input(lsDatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            init_operator_input: function(datas) {
                var _this = this;
                $(_this.$refs.operator).bsSuggest({
                    data: {
                        value: datas
                    },
                    ignorecase: true,
                    showHeader: false,
                    showBtn: false,
                    delayUntilKeyup: true,
                    effectiveFields: ["name"],
                    idField: "id",
                    keyField: "name"
                }).on('onSetSelectValue', function(e, keyword, data) {
                    _this.operator = data.name;
                });
            },
            nowCon: function() {
                var _this = this;
                if(_this.operator == '') {
                    $(_this.$refs.operator).removeAttr("data-id");
                } else if($(_this.$refs.operator).attr('data-id') == '') {
                    let operatorId = $(_this.$refs.operatorDown).find($("[data-id]")).attr('data-id');
                    $(_this.$refs.operator).attr('data-id', operatorId);
                }
            },
            // 门店2
            initi_add_shop_name: function(info, shop_id, store_id, rowid) {
                var _this = this;
                var selectdata = this.selectdata;
                // selectdata.splice(0, 1);
                // selectdata.unshift({ id: "", text: ""});
                $(_this.$refs.detailshop).html("");
                if(info == 'detail') {
                    $(_this.$refs.detailshop).select2({
                        data: selectdata,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        language: "zh-CN",
                        width: '100%'
                    });
                    _this.getstockdata(shop_id, 'false', store_id, info, rowid);
                    $(_this.$refs.detailshop).prop("disabled", true);
                    $(_this.$refs.add_stock_name).prop("disabled", true);
                } else if(info == 'add') {
                    $(_this.$refs.detailshop).select2({
                        data: selectdata,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        language: "zh-CN",
                        width: '100%'
                    }).on("select2:select",function(e){
                        $(_this.$refs.add_stock_name).prop("disabled", false);
                        _this.getstockdata(e.params.data.id, 'false');
                    });
                }

                $(_this.$refs.add_stock_name).on("select2:select", function(e) {
                    let id = e.params.data.id;
                    if(_this.detail_list.length > 0) { //已选择商品
                        layer.confirm('修改仓库，上次添加商品数据将不保存，确定修改？', {
                            btn: ['确定', '取消'], //按钮
                            title: ['提示', true]
                        }, function() {
                            layer.closeAll();
                            _this.detail_list = [];
                            $(_this.$refs.detaillist).bootstrapTable('destroy');
                            _this.preremainid = id;
                        }, function() {
                            layer.closeAll();
                            $(_this.$refs.add_stock_name).select2("val",[_this.preremainid]);
                            return;
                        });
                    } else {
                        _this.preremainid = id;
                    }
                });
                $(_this.$refs.detailshop).on("select2:select", function (e) {
                    let id = e.params.data.id;
                    if(_this.detail_list.length > 0) {
                        layer.confirm('修改门店，上次添加商品数据将不保存，确定修改？', {
                            btn: ['确定', '取消'], //按钮
                            title: ['提示', true]
                        }, function() {
                            layer.closeAll();
                            _this.detail_list = [];
                            $(_this.$refs.detaillist).bootstrapTable('destroy');
                            _this.preshopid = id;
                        }, function() {
                            layer.closeAll();
                            $(_this.$refs.detailshop).select2("val",[_this.preshopid]);
                            return;
                        });
                    } else {
                        _this.preshopid = id;
                    }
                });
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: _this.IntstartTime,
                    endDate: _this.IntendTime
                }, function(start, end, label) {
                    _this.startTime = start.format('YYYY-MM-DD HH:mm');
                    _this.endTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 清空日期
            clearDate: function() {
                this.startTime = "";
                this.endTime = "";
            },
            // 点击“查询”按钮
            queryList: function() {
                this.innitTable();
            },
            // 点击“新增报损单”
            addPurchase: function() {
                let _this = this;
                // 清空详情页数据
                _this.theDetail = {};
                _this.detail_list = [];
                $(_this.$refs.detaillist).bootstrapTable('destroy');
                _this.visible = true;
                _this.pagetitle = "新增报损单";
                _this.showNumandTime = false;
                _this.initi_add_shop_name('add');

                $(_this.$refs.detailshop).val(this.selectdata[0].id).trigger("change");
                $(_this.$refs.detailshop).prop("disabled", false); //可用
                _this.getstockdata(this.selectdata[0].id, 'false');
                $(_this.$refs.add_stock_name).prop("disabled", false);
                _this.remark = "";
                $(_this.$refs.remark).prop("disabled", false);

                $(_this.$refs.detailsupplier).val("null").trigger("change");
                $(_this.$refs.detailsupplier).prop("disabled", false); // 可用
                _this.$set(_this.theDetail, 'amount', '0.00'); // 默认设置为0.00
                _this.showdetail = true;
            },
            // 初始化报损单详情列表
            innitDetailTable: function(mark, pageNumber) {
                let _this = this;
                let actionEvents = {
                    'click .delete': function(e, value, row, index) {
                        layer.confirm("确定删除该商品吗？", {
                            btn: ['确定', '取消'], //按钮
                        }, function() {
                            let depositeData = [];
                            for(let i = 0; i < _this.detail_list.length; i++) {
                                if(_this.detail_list[i].merchant_goods_id != row.merchant_goods_id) {
                                    depositeData.push(_this.detail_list[i]);
                                }
                            }
                            _this.detail_list = depositeData;
                            // 刷新滚动条不变
                            let scollPostion = $('.tab-content').scrollTop();
                            _this.innitDetailTable(true, $(_this.$refs.detaillist).bootstrapTable('getOptions').pageNumber);
                            $('.tab-content').scrollTop(scollPostion);

                            layer.closeAll();
                            _this.updatePrice();
                        });
                    },
                    'click .editableicon': function(e, value, row, index) {
                        $(this).prev().addClass("editableinput-focus");
                        $(this).prev().attr("contenteditable", true);
                        $(this).addClass("editableiconend");
                        $(this).prev().focus();
                    },
                    'keypress .editableinput': function(e, value, row, index) {
                        if(event.keyCode == "13") {
                            $(this).blur();
                        }
                    },
                    'blur .editableinput': function(e, value, row, index) {
                        $(this).removeClass("editableinput-focus");
                        $(this).attr("contenteditable", false);
                        $(this).next().removeClass("editableiconend");
                        if($(e.target).hasClass("quantity") == true) { //数量编辑
                            console.log("quantity")
                            if(isNaN($(this).text())) {
                                layer.msg("请输入数字");
                                $(this).text(value);
                                return;
                            } else if($(this).text() < 1) {
                                layer.msg("数量不小于1");
                                $(this).text(value);
                                return;
                            } else if($(this).text().indexOf('.') != '-1') {
                                layer.msg("请输入整数");
                                $(this).text(value);
                                return;
                            }
                            for(let i = 0; i < _this.detail_list.length; i++) {
                                if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
                                    _this.detail_list[i].quantity = $(this).text();
                                    _this.detail_list[i].buying_price_total = (($(this).text() - 0) * (row.buying_price - 0)).toFixed(2)
                                    $(_this.$refs.detaillist).bootstrapTable('updateRow', {index: index, row: _this.detail_list[i]})
                                }
                            }
                        } else if($(e.target).hasClass("amount") == true) { // 单价编辑
                            if($(this).text() - 0 < 0) { // 价格不小于0
                                layer.msg("价格错误");
                                $(this).text("0.00");
                            }
                            for(let i = 0; i < _this.detail_list.length; i++) {
                                if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
                                    _this.detail_list[i].amount = $(this).text();
                                }
                            }
                        }
                        _this.updatePrice();
                    },
                };
                $(_this.$refs.detaillist).bootstrapTable('destroy');
                $(_this.$refs.detaillist).bootstrapTable({
                    pageNumber: pageNumber || 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    columns: [{
                        field: "merchant_goods_id",
                        title: "商品id",
                        visible: false
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "15%",
                        valign: "middle"
                    }, {
                        field: "goods_unit_name",
                        title: "商品单位",
                        width: "10%",
                        valign: "middle"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "10%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "报损数量",
                        width: "11%",
                        valign: "middle",
                        events: actionEvents,
                        formatter: function(value) {
                            if(_this.visible == false) {
                                return value;
                            } else {
                                if(value - 0 < 1) {
                                    value = "1"
                                }
                                return '<div class="editableinput quantity" contenteditable="false" >' + value + '</div> <a class="editableicon"></a>';
                            }
                        }
                    }, {
                        field: "remain_total",
                        title: "报损仓库存剩余",
                        width: "10%",
                        visible: mark
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "10%"
                    }, {
                        field: "buying_price_total",
                        title: "进货价合计",
                        width: "10%"
                    },  {
                        field: "op",
                        title: "操作",
                        width: "10%",
                        valign: "middle",
                        events: actionEvents,
                        formatter: function(value, row, index) {
                            return '<span class="text-blue delete">删除</span>'
                        }
                    }],
                    data: _this.detail_list
                });
            },
            // 点击“新增商品”
            addGoods: function() {
                let _this = this,
                    shop_id = $(_this.$refs.detailshop).val(),
                    store_id = $(_this.$refs.add_stock_name).val();
                if(shop_id == "") {
                    layer.msg("请选择门店");
                    return;
                }
                _this.innitSelect();
                $(_this.$refs.goodslist).bootstrapTable('destroy');
                _this.innitGoodsTable(store_id);
                layer.open({
                    type: 1,
                    title: '添加报损单商品',
                    skin: 'layui-layer-rim', // 加上边框
                    area: ['700px', '550px'], // 宽高
                    content: $(_this.$refs.addgoods)
                });
            },
            // 初始化添加进货商品弹窗的商品列表
            innitGoodsTable: function(store_id) {
                let _this = this;
                $(_this.$refs.goodslist).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 5,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getGoodsList(params, store_id);
                    },
                    sidePagination: "server",
                    columns: [{
                        checkbox: true,
                        title: "全选"
                    }, {
                        field: "merchant_goods_id",
                        title: "商品id",
                        visible: false
                    }, {
                        field: "goods_type_name",
                        title: "类型"
                    }, {
                        field: "merchant_goods_name",
                        title: "名称"
                    }, {
                        field: "goods_unit_name",
                        title: "单位"
                    }],
                    clickToSelect: true
                });
            },
            closeLayer: function() {
                layer.closeAll();
                this.clearPop();
            },
            // 清空弹窗的值
            clearPop: function() {
                $(this.$refs.goodtype).val("");
                $(this.$refs.goodname).val("");
                $(this.$refs.goodslist).bootstrapTable("destroy");
            },
            // 初始化商品类型选择框
            innitSelect: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.goodsType_list.push({
                                id: "0",
                                text: "全部"
                            });
                            $.each(data.response.result.data, function(k, v) {
                                _this.goodsType_list.push({
                                  id: v.id,
                                  text: v.name
                                });
                            });
                            $(_this.$refs.goodtype).select2({
                                allowClear: true,
                                data: _this.goodsType_list,
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取商品列表
            getGoodsList: function(params, store_id) {
                let _this = this,
                    goods_type = $(_this.$refs.goodtype).val(),
                    goods_name = $(_this.$refs.goodname).val(),
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "store_id": store_id,
                            "goods_type": goods_type,
                            "merchant_goods_name": goods_name,
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "all_sell": 1
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "merchantGoods/getStockGoodsList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 点击新增进货商品弹窗的“查询”按钮
            queryGoods: function() {
                $(this.$refs.goodslist).bootstrapTable("destroy");
                this.innitGoodsTable($(this.$refs.add_stock_name).val());
            },
            // 点击新增进货商品弹窗的“保存”按钮
            saveGoods: function() {
                let _this = this;
                $.map($(_this.$refs.goodslist).bootstrapTable('getSelections'), function(row) {
                    for(let i = 0; i < _this.detail_list.length; i++) {
                        if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
                            layer.msg("商品已存在");
                            return;
                        }
                    }
                    _this.detail_list.push({ merchant_goods_id: row.merchant_goods_id, goods_name: row.merchant_goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", remain_total: row.remain_total, buying_price: row.amount, buying_price_total: row.amount});
                    layer.msg("成功添加商品");
                });
                if(_this.detail_list.length == 0) {
                    layer.msg("报损商品不能为空");
                    return;
                }
                $(_this.$refs.detaillist).bootstrapTable("destroy");
                _this.innitDetailTable(true);
                // 更新价格
                _this.updatePrice();
            },
            // 更新进货总价
            updatePrice: function() {
                let _this = this;
                let totalPrice = 0;
                if(typeof($(_this.$refs.detaillist).bootstrapTable("getData")) == 'undefined') {
                    _this.theDetail.amount = totalPrice;
                    return;
                }
                $.each($(_this.$refs.detaillist).bootstrapTable("getData"), function(i, item) {
                    totalPrice = totalPrice + (item.quantity - 0) * (item.amount - 0);
                });
                _this.$set(_this.theDetail, 'amount', totalPrice);
            },
            // 提交报损单
            submitPurchase: function() {
                let _this = this,
                    shop_id = $(_this.$refs.detailshop).val(),
                    store_id = $(_this.$refs.add_stock_name).val();
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "store_id": store_id,
                            "remark": _this.remark,
                            "goods": _this.detail_list
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                layer.load(0, {
                    shade: [0.1, '#ececec'] // 0.1透明度的白色背景
                });
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/addDamage",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        layer.closeAll();
                        if(data.response.result_code == "true") {
                            $('#breakageSave').prop('disabled', true);
                            layer.msg("新增成功！");
                            // 显示时间和单号
                            _this.$set(_this.theDetail, "number", data.response.result.number);
                            _this.$set(_this.theDetail, "create_time", _this.getNowFormatDate());
                            _this.showNumandTime = true;
                            _this.innitTable();
                            // 返回列表页刷新列表
                            setTimeout(function() {
                                _this.showdetail = false;
                                _this.showNumandTime = false;
                                $('#breakageSave').prop('disabled', false);
                            }, 2000);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.closeAll();
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取当前时间
            getNowFormatDate: function() {
                var date = new Date();
                var seperator1 = "-";
                var seperator2 = ":";
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if(month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if(strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + date.getHours() + seperator2 + date.getMinutes() + seperator2 + date.getSeconds();
                return currentdate;
            },
            // 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "Store/damageExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.export_alert)
                }, function() {
                    _this.exportDetail();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 导出
            exportDetail: function() {
                let export_fields = JSON.stringify(this.export_checkModel);
                window.location.href = Vue.ctUrl + "Store/damageExport?" +
                    "id=" + this.theDetail.id +
                    "&export_fields=" + export_fields +
                    "&export_type=" + this.export_type;
                layer.msg("导出成功！");
                layer.closeAll();
            }
        }
    }
</script>

<style lang="less">
    .reported-loss {
        .detail-panel {
            .col-md-1,
            .col-md-3 {
                padding-left: 0;
            }
            .gray-head {
                padding: 20px 0;
                background-color: #f3f3f3;
                border-top: 8px solid #d7d7d7;
                .page-title {
                    height: 30px;
                    line-height: 30px;
                    font-size: 20px;
                    text-align: center;
                }
                .comment {
                    height: 30px;
                    margin-bottom: 20px;
                    line-height: 30px;
                    font-size: 12px;
                    color: #F00;
                    text-align: center;
                }
                .gray-center {
                    padding: 0 50px;
                    label {
                        line-height: 32px;
                        font-size: 14px;
                        text-align: right;
                    }
                    span {
                        line-height: 32px;
                        font-size: 14px;
                    }
                }
            }
            .add-goods {
                display: none;
                width: 100%;
                height: 100%;
                padding: 20px 30px;
                .btns {
                    margin-top: 10px;
                    #pop-save {
                        margin: 0 50px 0 180px;
                    }
                }
            }
        }
        .set-export {
            padding: 0 20px 20px;
            h3 {
                font-size: 16px;
            }
            li {
                float: left;
                width: 20%;
            }
        }
    }
</style>